import {
  EuiCallOut,
  EuiIcon,
  EuiStat,
  EuiTextColor,
} from "@inscopix/ideas-eui";

export const PublishOptionsFirstVersion = () => {
  return (
    <div>
      <EuiCallOut
        size="s"
        color="primary"
        iconType="iInCircle"
        title="This is the first version of this tool and it has been automatically assigned as version 1.0.0"
      />
      <EuiStat
        title="1.0.0"
        description={
          <EuiTextColor color="success">
            <span>
              <EuiIcon type="sortUp" /> Major
            </span>
          </EuiTextColor>
        }
        textAlign="left"
      ></EuiStat>
    </div>
  );
};
